/**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */
export default {
  path: "/app/recepcion",
  name: "RECEPTION_ROUTE",
  component: () => import("@/app/views/crud/CrudView.vue"),
  meta: {
    service: () => import("@/app/services/ReceptionService"),
    table: () => import("@/app/components/reception/ReceptionTable.vue"),
    form: () => import("@/app/components/reception/ReceptionForm.vue"),
    header: {
      icono: "mdi-account-multiple-outline",
      texto: "Recepción",
      textNew: "Registrar paciente",
      textEdit: "Actualizar paciente",
    },
    // prm: PRM.MODULE_PSYCHOLOGY_CONSULTATION,
    requireAuth: true,
    filterDate: true,
    hideButtonAdd: false,
    filterModality: true,
    cancelationModal: true,
    generatePDFModal: true,
    saveButtonText: "Guardar paciente",
    addButtonText: "Nuevo paciente",
    // hideSaveButton: true,
    // hideCancelButton: true,
  },
};
